export default __webpack_public_path__ + "static/media/night.90150abb.svg";